import { handleRetrievePopularForums } from "../../../../redux/public-slices/forum.slice";
import { Box, Divider, Grid2 as Grid, Skeleton, Stack, Typography } from "@mui/material";
import { handleRetrievePopularBlogs } from "../../../../redux/public-slices/blog.slice";
import SkeletonImage from "../../../ui/SkeletonImage";
import { FILE_PATH_URI } from "../../../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { Link as NavLink } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import moment from "moment";

function PopularPosts() {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [data, setData] = useState({});
  const route = pathname?.split("/")?.[1];
  const { loadings } = useSelector((state) => state.otherSlice);

  const handleRetrieve = async () => {
    let response = null;

    if (route === "forum-category" || route === "forum") {
      response = await dispatch(
        handleRetrievePopularForums({
          limit: 20,
        })
      ).unwrap();
    }
    if (route === "blog-category" || route === "blog") {
      response = await dispatch(
        handleRetrievePopularBlogs({
          limit: 20,
        })
      ).unwrap();
    }

    setData(response);
  };
  useEffect(() => {
    handleRetrieve();
    // eslint-disable-next-line
  }, []);

  return (
    <Stack
      divider={
        <Divider
          flexItem
          sx={{
            borderStyle: "dashed",
            borderColor: "other.color2",
          }}
        />
      }
      spacing={2}
    >
      {loadings?.retrievePopular
        ? new Array(4).fill().map((_, j) => (
          <Grid key={j} size={{ xs: 12, sm: 6, md: 4, lg: 6, xxl: 4 }}>
            <Skeleton
              sx={{ width: "100%", aspectRatio: "1/1.3", transform: "none" }}
            />
          </Grid>
        ))
        : data?.records?.map((element, i) => (
          <Grid key={i} container spacing={1}>
            <Grid
              size="auto"
              component={NavLink}
              to={
                route === "forum-category" || route === "forum"
                  ? `/forum/${element?._id}`
                  : `/blog/${element?._id}`
              }
            >
              <Box
                sx={{
                  width: "110px",
                  aspectRatio: "1/0.6",
                }}
              >
                <SkeletonImage
                  src={FILE_PATH_URI + element?.banner?.path}
                  sx={{ objectFit: "cover" }}
                />
              </Box>
            </Grid>
            <Grid size="grow">
              <Typography
                mb={0.5}
                fontWeight="500"
                lineHeight="1.3"
                color="other.color1"
                overflow={"hidden"}
                sx={{
                  display: "-webkit-box",
                  textDecoration: "none",
                }}
                component={NavLink}
                to={
                  route === "forum-category" || route === "forum"
                    ? `/forum/${element?._id}`
                    : `/blog/${element?._id}`
                }
              >
                {element?.title}
              </Typography>
              <Typography
                fontSize={14}
                lineHeight="1"
                fontWeight="500"
                component="span"
                color="other.color2"
              >
                {moment(element?.createdAt).format("MMM DD YYYY")}
              </Typography>
              <Typography color="other.color2" fontSize={{ xs: 14, md: 16 }}>
                {element?.views || 0} Views
              </Typography>
            </Grid>
          </Grid>
        ))}
    </Stack>
  );
}

export default PopularPosts;
